import store from "@/store";
import { currencySymbols, dataSourceTypes, localStorageKeys } from "@/enums";

function capitalize(text) {
  if (!text || !text.length) return '';

  return text.toLowerCase()
    .replace(/^(\w)|\s(\w)/g, (grp) => grp.toUpperCase());
}

function getPriorityIcon(priority) {
  let icon = "";
  const type = priority.toString().toLowerCase();
  if (type == "perfect") icon = "perfect-rocket.svg"
  else if (type == "opportunity") icon = "opportunity-lightbulb.svg"
  else if (type == "warning") icon = "warning-sync-exclamation.svg"
  else if (type == "urgent") icon = "urgent-exclamation-triangle.svg"
  else if (type == "report") icon = "report.svg"
  return icon
}

function getSourceTypeIcon(sourceType) {

  const dataSourceTypesIcons = {
    [dataSourceTypes.googleAnalytics]: "google-analytics.svg",
    [dataSourceTypes.googleAnalytics4]: "google-analytics.svg",
    [dataSourceTypes.googleAds]: "google-adwords.svg",
    [dataSourceTypes.googleAdwords]: "google-adwords.svg",
    [dataSourceTypes.googleSearchConsole]: "google-search.svg",
    [dataSourceTypes.facebook]: "facebook.svg",
    [dataSourceTypes.shopify]: "shopify.svg"
  };

  return dataSourceTypesIcons[sourceType];
}

function hasCancelRequest(error) {
  if (!(error?.message?.status)) return false;
  const statusCode = error.message.status;
  return store.getters['common/getAxiosCancelStatusCodes'].includes(statusCode)
}

function validateEmail(email) {
  const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return regex.test(email);
}

function secureInput(input) {
  // source link:https://gomakethings.com/how-to-sanitize-third-party-content-with-vanilla-js-to-prevent-cross-site-scripting-xss-attacks/#sanitizing-by-encoding
  return input.replace(/[^\w. ]/gi, function (c) {
    return '&#' + c.charCodeAt(0) + ';';
  });
}

function slugify(string) {
  //source link:https://gist.github.com/hagemann/382adfc57adbd5af078dc93feef01fe1


  const specialCharacters = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìıİłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;';
  const regularCharacters = 'aaaaaaaaaacccddeeeeeeeegghiiiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------';
  const regex = new RegExp(specialCharacters.split('').join('|'), 'g');

  return string.toString().toLowerCase()
    .replace(/\s+/g, '-') // Replace spaces with -
    .replace(regex, character => regularCharacters.charAt(specialCharacters.indexOf(character))) // Replace special characters
    .replace(/&/g, '-and-') // Replace & with 'and'
    .replace(/[^\w\-]+/g, '') // Remove all non-word characters
    .replace(/\-\-+/g, '-') // Replace multiple - with single -
    .replace(/^-+/, '') // Trim - from start of text
    .replace(/-+$/, '') // Trim - from end of text
}

function htmlEntities(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function changeGeneralLocalStorageVariables(data){
  store.commit('common/changeGeneralLocalStorageVariables', data);
}

function removeGeneralLocalStorageVariables(data) {
  store.commit("common/removeGeneralLocalStorageVariables", data);
}

function getLocalStorageValueByKey(key){
  return store.getters['common/getLocalStorageValueByKey'](key);
}

function storageListener() {
  window.addEventListener("storage", (event) => {

    if (event.key != localStorageKeys.heybooster) return;

    const newValue = JSON.parse(event.newValue);
    const oldValue = JSON.parse(event.oldValue);
    let reload = false;

    if (newValue.activeClientID && newValue.activeClientID != oldValue.activeClientID) {
      reload = true;
    } else if (newValue.logout) {
      reload = true;
    }

    if (reload) {
      window.location.reload();
    }
  });
}

function getSymbolFromCurrency(currencyCode) {
  if (typeof currencyCode !== "string") return ;

  const code = currencyCode.toUpperCase();

  if (!currencySymbols.hasOwnProperty(code)) return ;

  return currencySymbols[code];
}

export {
  capitalize,
  getPriorityIcon,
  getSourceTypeIcon,
  hasCancelRequest,
  validateEmail,
  secureInput,
  changeGeneralLocalStorageVariables,
  getLocalStorageValueByKey,
  slugify,
  htmlEntities,
  removeGeneralLocalStorageVariables,
  storageListener,
  getSymbolFromCurrency
}



// WEBPACK FOOTER //
// ./src/helpers/common/index.js